import { getUserDetails } from '../../actions/userActions';
import Breadcrumbs, { getCrumbs } from '../common/Breadcrumbs';
import Messages from '../includes/Messages';
import PromoBox from '../includes/PromoBox';
import NotFound from './NotFound';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router';

const getPath = (tile, urlParts) => {
  const formType = (tile.formTypes || [])[0] || {};
  // Special case: Go directly to the search form
  if (formType.id === 'RECERT-VOLUNTEER-SEARCH') {
    return '/search_peer_volunteer'; // Special search path.
  }
  // Special cases: Go directly to the form!
  if (formType.formDisplay) {
    const form = formType.forms[0] || {};
    return '/form/' + formType.id + '/' + form.formId;
  }
  return tile.subTiles ? '/sub/' + urlParts.join('/') + '/' + tile.type : '/forms/' + tile.type;
};

/**
 * Container for our lists of form options.
 *
 * Should show a login form if we're logged out.
 */
const SubDashboard = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const dashboard = useSelector((state) => state.dashboard);
  const content = useSelector((state) => state.config.content.dashboard);
  const tilesContentAll = useSelector((state) => state.config.content.tiles);
  const sessionId = useSelector((state) => state.user.sessionId);

  // Fetch user details on load
  useEffect(() => {
    if (sessionId !== null) {
      dispatch(getUserDetails(sessionId));
    }
  }, [sessionId, dispatch]);

  // Prepare data for display
  let tiles = [];
  let tlsContent = tilesContentAll;
  if (typeof dashboard.tiles !== 'undefined') {
    // Sort tiles according to sort order set in config
    tiles = dashboard.tiles.slice(0);
    tiles.sort(function (a, b) {
      for (let i = 0, ii = content.tileOrder.length; i < ii; i++) {
        if (content.tileOrder[i] === a.type) {
          return -1;
        }
        if (content.tileOrder[i] === b.type) {
          return 1;
        }
      }
      return 0;
    });
  }

  // Find tile type from the URL
  let foundTile = false;

  const pathAfterSub = location.pathname.replace(/^\/sub\/?/, '');
  const urlParts = pathAfterSub.split('/').filter(Boolean);

  // Use the url to identify page content
  let parentTitle;
  let parentSubtitle;
  for (let i = 0; i < urlParts.length; i++) {
    // Iterate over tiles
    for (let j = 0; j < tiles.length; j++) {
      if (urlParts[i] === tiles[j].type) {
        // Identify parent tile
        let parentTile = tlsContent[tiles[j].type] || [];
        foundTile = true;

        // Text to display based on the parent tile
        parentTitle = parentTile.title ? parentTile.title : tiles[j].name;
        parentSubtitle = parentTile.subtitle ? parentTile.subtitle : undefined;

        // Isolate child content of the parent tile
        tlsContent = (tlsContent[tiles[j].type] || {}).subTiles || {};
        tiles = tiles[j].subTiles || [];

        break;
      }
    }
  }

  // Info for BreadCrumbs component
  const passedBreadCrumbs = location.state?.breadCrumbs || [];
  const currentBreadCrumb = { title: parentTitle, url: location.pathname };
  const breadCrumbId = 'SubDashboard' + parentTitle;
  const breadCrumbParts = getCrumbs(passedBreadCrumbs, currentBreadCrumb, breadCrumbId);

  let bannerHtml = {};
  bannerHtml['__html'] = content.banner.content;

  return (
    <div>
      {/* Subtitle */}
      {parentSubtitle ? (
        <PromoBox>
          <p className="intro">{parentSubtitle}</p>
        </PromoBox>
      ) : null}

      <section>
        <Breadcrumbs crumbs={breadCrumbParts} />

        {/* Editable forms */}
        <div className="container content">
          <div className="row middle">
            <div className="col-lg-12">
              <Messages />
            </div>

            {!foundTile || tlsContent.length === 0 || tiles.length === 0 ? (
              <NotFound />
            ) : (
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
                {tiles.map((tile) => {
                  const tlContent = tlsContent[tile.type] || {};
                  return (
                    <div key={tile.type} className="col frank-tile">
                      <Link to={{ pathname: getPath(tile, urlParts) }} state={{ breadCrumbs: breadCrumbParts }}>
                        <div className="bg-mint p-4 h-100">
                          <h3>{tlContent.title || tile.name}</h3>
                          {tlContent.intro && <p>{tlContent.intro}</p>}
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Banner */}
      {content.banner.content ? (
        <div className="page-title bg-black">
          <img alt={content.banner.title} src="/assets/Uploads/Photos/banner-about.jpg" className="banner hidden-sm hidden-xs" />
          <div className="container">
            <div className="row banner hidden-sm hidden-xs">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="img-overlay bg-black">
                  <div className="content-wrap ">
                    <span className="fi-stack fi-3x">
                      <i className="fi fi-circle-solid fi-stack-2x"></i>
                      <i className="fi fi-building fi-stack-1x fi-inverse"></i>
                    </span>

                    {content.banner.title ? <h2>{content.banner.title}</h2> : null}
                    {/* eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml */}
                    <div className="typography" dangerouslySetInnerHTML={bannerHtml} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SubDashboard;
